module.exports = __webpack_public_path__ + "img/2-3.11e2e0b6.svg";